import { ConfigService } from './config.service';

export const configFactory = (configService: ConfigService) => () => configService.loadConfig();
